import React, { useState } from 'react'
import { PageBanner } from 'cwp-components/PageBanner'
import { TableBody, TableHeader } from './components/Card'
import { data } from 'data/DocumentLibraryData'
import './index.scss'
import FilteringPane from './components/Filter'
import { BsDownload } from 'react-icons/bs'

const DocumentLibrary = () => {
  const [state, setState] = useState()
  const [libraryList, setLibraryList] = useState(data)

  return (
    <>
      <PageBanner>Document Library</PageBanner>
      <div className='md:mx-[127px] mx-[20px] my-[80px]'>
        <FilteringPane />

        <div className='relative my-[100px]'>
          <table className='w-full border-separate border-spacing-y-[8px] !appearance-none '>
            <thead className='text-xs text-[#1C7D93] text-[14px] border-none '>
              <tr className='text-left'>
                <th className=' p-4'>
                  <div className='flex items-center'>
                    <input
                      id='checkbox-all-search'
                      type='checkbox'
                      className='w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600'
                    />
                    <label htmlFor='checkbox-all-search' className='sr-only'>
                      checkbox
                    </label>
                  </div>
                </th>
                <th className='max-sm:hidden px-6 py-3'>Document name</th>
                <th scope='col' className='max-sm:hidden px-6 py-3'>
                  Description
                </th>
                <th scope='col' className='max-sm:hidden px-6 py-3'>
                  Date purchased
                </th>
                <th scope='col' className='max-sm:hidden px-6 py-3'>
                  Document owner
                </th>
                <th scope='col' className='max-sm:hidden px-6 py-3'>
                  Invoice
                </th>
                <th scope='col' className='max-sm:hidden px-6 py-3'>
                  Status
                </th>
                <th scope='col' className='max-sm:hidden px-6 py-3'></th>
              </tr>
            </thead>
            <tbody className='text-[14px]  w-full'>
              {data.map((data: any, idx: any) => (
                <tr className=' bg-[rgba(244,244,244,0.30)] rounded-[10px] !border-[#9FB7D7] shadow-[#BBD2D7_0px_0.2px_4px_0px] max-sm:grid max-sm:grid-cols-[10%_90%] p-[16px] max-sm:gap-3 max-sm:my-[20px]'>
                  <td className='row-span-7 md:p-4'>
                    <input
                      id='checkbox-table-search-1'
                      type='checkbox'
                      className='w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-[#1C7D93] dark:focus:ring-[#1C7D93]'
                    />
                    <label
                      htmlFor='checkbox-table-search-1'
                      className='sr-only'
                    >
                      checkbox
                    </label>
                  </td>
                  <td className=''>
                    <div className='max-sm:mt-[-4px]'>
                      <p>Legal requirement.pdf</p>
                      <span>200MB</span>
                    </div>
                  </td>
                  <td className=' md:w-[270px]'>
                    Description, lorem ipsum lorem ipsum lorem ipsum lorem ipsum
                    lorem ipsum
                  </td>
                  <td>
                    <span className='md:hidden font-medium w-full text-[#1C7D93]'>
                      Date Purchased:{' '}
                    </span>
                    Jan 4, 2022
                  </td>
                  <th>
                    <p className='md:hidden text-left max-sm:w- font-medium w-full text-[#1C7D93]'>
                      Date Purchased:{' '}
                    </p>
                    <div className='flex items-center mt-2 text-gray-900 whitespace-nowrap'>
                      <div
                        className='w-10 h-10 rounded-full'
                        style={{
                          background: `url(${data.owner[0].avatar_url}) lightgray 50% / cover no-repeat`,
                        }}
                      />
                      <div className='ps-3'>
                        <div className='text-dark text-left'>Neil Sims</div>
                        <div className='font-normal text-gray-500'>
                          {data.owner[0].email}
                        </div>
                      </div>
                    </div>
                  </th>
                  <td className='max-sm:w-full'>
                    <span className='md:hidden text-left  font-medium w-full text-[#1C7D93]'>
                      Status:{' '}
                    </span>
                    Active
                  </td>
                  <td className=''>
                    <div className='flex items-center'>
                      <span className='md:hidden text-left  font-medium md:w-full  text-[#1C7D93]'>
                        Invoice:
                      </span>{' '}
                      <BsDownload className='ml-2' />
                    </div>
                  </td>
                  <td className='max-sm:w-full  '>
                    <div className='flex justify-center gap-[12px]'>
                      <button className='h-[24px] w-[76px] p-[4px_8px] rounded-[4px] leading-[16px] text-[#1C7D93] text-[12px] shadow-[0px_1px_4px_0px_rgba(0,0,0,0.25)]'>
                        Create
                      </button>
                      <button className='h-[24px] w-[135px] p-[4px_8px] rounded-[4px] leading-[16px] text-[12px]  shadow-[0px_1px_4px_0px_rgba(0,0,0,0.25)] text-white bg-[#020251] '>
                        Purchase
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* {data &&
          data.map((library: any, idx: any) => (
            <TableBody
              setLibraryList={setLibraryList}
              libraryList={libraryList}
              key={idx}
              data={library}
            />
          ))} */}
      </div>
    </>
  )
}

export default DocumentLibrary
